module.exports = require("@wildboar/x500/src/lib/modules/DistributedOperations/ChainingResults.ta");